import "./App.css";
import { Routes, Route } from "react-router-dom";
import Mainview from "./components/LandingPage/mainview/mainview";
import Layout from "./components/Layout/layout";
import ContactPage from "./components/ContactPage/contactPage";
import Coq9Demo from "./components/DemoPages/coq9";
import THEMDemo from "./components/DemoPages/them_demo";
import ANKZF1Demo from "./components/DemoPages/ankzf1";
import PINK1Demo from "./components/DemoPages/pink1";
import MtDNADemo from "./components/DemoPages/mtdna";
import POLGClinicalDemo from "./components/DemoPages/polg_clinical.jsx";
import KSSClinicalDemo from "./components/DemoPages/kss_clinical.jsx";
import MELASClinicalDemo from "./components/DemoPages/melas_clinical.jsx";
import POLGCpeoClinicalDemo from "./components/DemoPages/polg_cpeo_clinical.jsx";

// import ScrollToTop from "./components/scrollToTop";

function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout>
            <Mainview />
          </Layout>
        }
      />
      <Route
        path="/playground"
        element={
          <Layout>
            <ContactPage />
          </Layout>
        }
      />
      <Route
        path="/demo/coq9"
        element={
          <Layout>
            <Coq9Demo />
          </Layout>
        }
      />
      <Route
        path="/demo/tmem"
        element={
          <Layout>
            <THEMDemo />
          </Layout>
        }
      />
      <Route
        path="/demo/ankzf1"
        element={
          <Layout>
            <ANKZF1Demo />
          </Layout>
        }
      />
      <Route
        path="/demo/pink1"
        element={
          <Layout>
            <PINK1Demo />
          </Layout>
        }
      />

      <Route
        path="/demo/mtdna"
        element={
          <Layout>
            <MtDNADemo />
          </Layout>
        }
      />

      <Route
        path="/demo/polg-clinical"
        element={
          <Layout>
            <POLGClinicalDemo />
          </Layout>
        }
      />

      <Route
        path="/demo/kss-clinical"
        element={
          <Layout>
            <KSSClinicalDemo />
          </Layout>
        }
      />
      <Route
        path="/demo/melas-clinical"
        element={
          <Layout>
            <MELASClinicalDemo />
          </Layout>
        }
      />
      <Route
        path="/demo/cpeo-clinical"
        element={
          <Layout>
            <POLGCpeoClinicalDemo />
          </Layout>
        }
      />
    </Routes>
  );
}

export default App;
